import React from 'react';

import cookie from 'react-cookies';
import PropTypes from 'prop-types';
import connect from 'react-redux/lib/connect/connect';
import bindActionCreators from 'redux/lib/bindActionCreators';

import * as PayrollDucks from 'ducks/payrolls/payroll';
import * as RouteDucks from 'ducks/routes';
import * as InfoDucks from 'ducks/info/info';

import TwoColumnLayout from 'layouts/TwoColumn';
import PayrollListSection from 'sections/payrolls/list/List';
import PayrollFilterSection from 'sections/payrolls/list/Filter';

import { NAV } from 'constants/payrolls';

/**
 * PayrollListPage
 *
 * Layout:
 *    - {@link TwoColumnLayout}
 *
 * Sections:
 *    - {@link PayrollFilterSection}
 *    - {@link PayrollListSection}
 *
 * Fetch Needs:
 *    - getPayrolls
 */
class PayrollListPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false, isInfoOpen: true };
    this.toggleInfo = this.toggleInfo.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  componentWillMount() {
    
    const cookieKey = cookie.load("payroll_list_info");
    if(cookieKey) {
      this.setState({isInfoOpen: JSON.parse(cookieKey)});
    }
    this.props.InfoDucks.getInformations({route: 'payroll.list'});
    this.loadData();
  }


  componentWillReceiveProps(nextProps) {
    const { location: { query: prevQuery } } = this.props;
    const { location: { query: nextQuery } } = nextProps;

    if (prevQuery !== nextQuery) {
      this.fetchData(nextQuery);
    }
  }

  componentWillUnmount(){
    this.props.InfoDucks.resetInformations();
  }

  fetchData(params) {
    this.setState({ isLoading: true });
    const pageSize = cookie.load('payroll_page_size');
    return this.props.PayrollDucks.getPayrolls({...params, page_size: pageSize})
      .then(() => this.setState({ isLoading: false }))
      .catch(() => this.setState({ isLoading: false }));
  }

  loadData(){
    const { location: { query } } = this.props;
    this.fetchData(query);
  }

  toggleInfo(){
    const { isInfoOpen } = this.state;
    this.setState({ isInfoOpen: !isInfoOpen });
    cookie.save("payroll_list_info", !isInfoOpen);
  }

  render() {
    const { infoList } = this.props;
    const { isInfoOpen } = this.state;
    return (
      <TwoColumnLayout
        navInfo={NAV.PayrollListPage}
        infoList={infoList}
        toggleInfo={this.toggleInfo}
        isInfoOpen={isInfoOpen}
        fetchData={this.loadData}
      >
        <PayrollFilterSection />
        <PayrollListSection isLoading={this.state.isLoading} />
      </TwoColumnLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  location: RouteDucks.location(state),
  infoList: InfoDucks.infoList(state),
});

const mapActionsToProps = dispatch => ({
  PayrollDucks: bindActionCreators(PayrollDucks, dispatch),
  InfoDucks: bindActionCreators(InfoDucks, dispatch),
});

PayrollListPage.propTypes = {
  PayrollDucks: PropTypes.object.isRequired,
  InfoDucks: PropTypes.object.isRequired,
  infoList: PropTypes.object.isRequired,
};

PayrollListPage.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(PayrollListPage);
